import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { can } from "../../config/adminRbac";

/**
 * Gate a screen by RBAC module (GET /admin/me/permissions).
 * @param {string|null} module - Backend module key, or null to allow any logged-in user
 * @param {"read"|"create"|"update"|"delete"|"statusUpdate"} [action="read"] - Required permission bit
 */
export default function PermissionRoute({
  module: moduleKey,
  children,
  action = "read",
}) {
  const perm = useSelector((s) => s.permissions);

  if (perm.fruitMode) {
    return children;
  }
  if (!perm.loaded) {
    return null;
  }
  if (!moduleKey) {
    return children;
  }
  if (!can(perm, moduleKey, action)) {
    return <Navigate to="/forbidden" replace />;
  }
  return children;
}
